import { render, staticRenderFns } from "./MySellGoods.vue?vue&type=template&id=390a7412&scoped=true"
import script from "./MySellGoods.vue?vue&type=script&lang=js"
export * from "./MySellGoods.vue?vue&type=script&lang=js"
import style0 from "./MySellGoods.vue?vue&type=style&index=0&id=390a7412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390a7412",
  null
  
)

export default component.exports